export default "__VITE_ASSET__DwpqAAlc__"